// extracted by mini-css-extract-plugin
export var small = "service-template-small-module--small--3LTZ0";
export var image = "service-template-small-module--image--3uTne";
export var orderName = "service-template-small-module--orderName--1gNKF";